module.exports = __webpack_public_path__ + "img/hatching_eggs.80533f82.svg";